export default __webpack_public_path__ + "static/media/FFHXNzmaUAAZ8gT.aeebc913.jpg";